import React from "react";
import firebase from "firebase.config";
import Page4 from "./Page4";
import Page5 from "./Page5";

export default class GroupDetails extends React.Component {
  state = {
    name: "",
    image: "",
    uploading: false,

    page4: [
      {
        title: "",
        url: ""
      }
    ],

    page5Title: "",
    page5: [
      {
        image: null,
        title: "",
        buttons: [
          {
            image: null,
            title: "",
            htmlData: ""
          }
        ]
      }
    ]
  };

  // ----- Tailwind 공통 입력 스타일 -----
  inputCls =
    "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 shadow-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200";

  componentDidMount = () => {
    this.initialize();
  };

  initialize = () => {
    if (this.props.groupData.pageNames) {
      // Page 4 Title
      var temp = this.state.page4;
      temp[0].title = this.props.groupData.pageNames.page4;
      this.setState({ page4: temp });

      // Page 5 Title
      this.setState({
        page5Title: this.props.groupData.pageNames.page5
      });
    }

    // Page 4 URL
    if (this.props.groupData) {
      var temp = this.state.page4;

      temp[0].url = this.props.groupData.youtubeUrl;

      this.setState({
        page4: temp
      });
    }

    // Page 5 Data
    if (this.props.groupData.page5) {
      var temp = this.state.page5;

      temp[0].image = this.props.groupData.page5.image;
      temp[0].title = this.props.groupData.page5.title;
      temp[0].buttons = this.props.groupData.page5.buttons;

      this.setState({
        page5: temp
      });
    }
  };

  handleChange = (event, key) => {
    this.setState({
      [key]: event.target.value
    });
  };

  // *************************
  //   PUSH DATA TO DATABASE
  // *************************

  pushPageNamesToDB = async () => {
    await firebase
      .database()
      .ref("groupsData/" + this.props.userDetails.groupPath + "/pageNames/")
      .update({
        page4: this.state.page4[0].title,
        page5: this.state.page5Title
      });
  };

  pushPage4DataToDB = async () => {
    await firebase
      .database()
      .ref("groupsData/" + this.props.userDetails.groupPath)
      .update({
        youtubeUrl: this.state.page4[0].url
      });
  };

  pushPage5DataToDB = async () => {
    await firebase
      .database()
      .ref("groupsData/" + this.props.userDetails.groupPath)
      .update({
        page5: this.state.page5[0]
      });
  };

  updateDetails = () => {
    let { name } = this.state;
    if (name.length === 0) {
      name = this.props.groupData.name;
    }
    if (name.length < 2) {
      alert("Please enter valid group name");
      return;
    }

    firebase
      .database()
      .ref("/groupsData/" + this.props.userDetails.groupPath)
      .update({
        name,
        image: this.state.image ? this.state.image : this.props.groupData.image
      })
      .then(res => {
        this.setState({
          name: ""
        });
        alert("Updated successfully");
      });

    this.pushPage4DataToDB();
    this.pushPage5DataToDB();
    this.pushPageNamesToDB();
  };

  saveImage = async event => {
    this.setState({
      uploading: true
    });
    let file = event.target.files[0];

    if (file) {
      var filename = this.props.userDetails.group + "-logo";

      const storage = firebase.storage().ref();
      const image = storage.child(filename);

      await image.put(file).then(async snapshot => {
        await image.getDownloadURL().then(async url => {
          this.setState({
            image: url,
            uploading: false
          });
        });
      });
      console.log("Image Uploaded!!!");
    }
  };

  setPageNames = (event, index) => {
    var temp = this.state.pageNames;

    temp[index] = event.target.value;

    this.setState({
      pageNames: temp
    });
  };

  // ****************************
  //   PAGE 4 ONCHANGE FUNCTION
  // ****************************

  handleURLChange = value => {
    let temp = this.state.page4;

    temp[0].url = value;

    this.setState({
      page4: temp
    });
  };

  handlePage4TitleChange = value => {
    let temp = this.state.page4;

    temp[0].title = value;

    this.setState({
      page4: temp
    });
  };

  // ****************************
  //   PAGE 5 ONCHANGE FUNCTION
  // ****************************

  handlePage5TitleChange = value => {
    this.setState({
      page5Title: value
    });
  };

  addHeader = () => {
    var temp = this.state.page5;

    temp[0].buttons.push({
      image: null,
      title: "",
      htmlData: ""
    });

    this.setState({
      page5: temp
    });
  };

  handleTitleChange = (value, index) => {
    let temp = this.state.page5;
    console.warn(value);
    temp[0].buttons[index].title = value;

    this.setState({
      page5: temp
    });
  };

  handleEditorChange = (value, index) => {
    let items = this.state.page5;

    items[0].buttons[index].htmlData = value;

    this.setState({
      page5: items
    });
  };

  handleEditorUpdate = (val, index) => {
    let items = this.state.page5;

    items[0].buttons[index].htmlData = val;

    this.setState({
      page5: items
    });
  };

  render() {
    if (!this.props.userDetails.group) {
      return (
        <div className="content">
          <div className="mx-auto w-full max-w-3xl px-2 pb-10">
            <div className="rounded-2xl border border-amber-200 bg-amber-50 p-6 text-sm text-amber-700">
              <b>{this.props.userDetails.name}</b>님, 그룹 정보를 수정하려면 먼저
              대시보드에서 그룹 고유 ID를 설정해 주세요.
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="content">
        <div className="mx-auto w-full max-w-3xl px-2 pb-10">
          {/* 안내 배너 */}
          <div className="mb-6 rounded-2xl bg-gradient-to-r from-sky-500 to-cyan-400 p-6 text-white shadow-lg">
            <h2 className="mb-1 text-2xl font-bold">⚙️ 그룹 정보</h2>
            <p className="text-sm leading-relaxed text-sky-50">
              그룹 이름과 로고, 추가 페이지(유튜브·서브 페이지) 정보를 설정하세요.
              모두 입력한 뒤 맨 아래 <span className="font-semibold">[저장]</span>{" "}
              버튼을 누르면 반영됩니다.
            </p>
          </div>

          {/* 기본 정보 */}
          <section className="mb-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                1
              </span>
              <h3 className="text-lg font-bold text-gray-800">그룹 기본 정보</h3>
            </div>

            <div className="space-y-4">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                  <label className="mb-1 block text-xs font-semibold text-gray-600">
                    그룹 ID (변경 불가)
                  </label>
                  <input
                    type="text"
                    placeholder="그룹 ID"
                    value={this.props.userDetails.group}
                    disabled={true}
                    className={this.inputCls + " cursor-not-allowed bg-gray-100 text-gray-400"}
                    onChange={event => this.handleChange(event, "name")}
                  />
                </div>
                <div>
                  <label className="mb-1 block text-xs font-semibold text-gray-600">
                    그룹 이름
                  </label>
                  <input
                    type="text"
                    placeholder="예) 와우스 뉴스레터"
                    defaultValue={
                      this.props.groupData ? this.props.groupData.name : ""
                    }
                    className={this.inputCls}
                    onChange={event => this.handleChange(event, "name")}
                  />
                </div>
              </div>

              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  그룹 로고
                </label>
                <div className="flex flex-col items-start gap-4 rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 p-4 sm:flex-row sm:items-center">
                  <label className="inline-flex cursor-pointer items-center gap-2 rounded-lg bg-sky-500 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-sky-600">
                    🖼️ 로고 선택
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={event => this.saveImage(event)}
                    />
                  </label>
                  {this.props.groupData.image || this.state.image ? (
                    <img
                      src={
                        this.state.image
                          ? this.state.image
                          : this.props.groupData.image
                      }
                      alt="로고 미리보기"
                      className="h-16 w-auto rounded-lg shadow"
                    />
                  ) : (
                    <span className="text-xs text-gray-400">
                      아직 로고를 선택하지 않았어요.
                    </span>
                  )}
                </div>
              </div>
            </div>
          </section>

          {/* Page 4 */}
          <Page4
            obj={this.state.page4}
            onUrlChange={value => {
              this.handleURLChange(value);
            }}
            onTitleChange={value => {
              this.handlePage4TitleChange(value);
            }}
          />

          {/* Page 5 */}
          <Page5
            obj={this.state.page5}
            key={this.state.page5}
            title={this.state.page5Title}
            onTitleChange={value => {
              this.handlePage5TitleChange(value);
            }}
            onAddHeader={() => {
              this.addHeader();
            }}
            onHandleTitleChange={(value, index) => {
              this.handleTitleChange(value, index);
            }}
            onHandleEditorChange={(value, index) => {
              this.handleEditorChange(value, index);
            }}
            onHandleEditorUpdate={(value, index) => {
              this.handleEditorUpdate(value, index);
            }}
          />

          {/* 저장 */}
          <div className="mx-auto w-full max-w-3xl px-2">
            <div className="flex justify-end">
              <button
                type="button"
                disabled={this.state.uploading}
                className="inline-flex items-center gap-2 rounded-xl bg-sky-500 px-6 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-sky-600 disabled:cursor-not-allowed disabled:opacity-50"
                onClick={() => this.updateDetails()}
              >
                💾 그룹 정보 저장
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
